import Base from '../../../Core/Base.js';
import Events from '../../../Core/mixin/Events.js';

/**
 * @module Gantt/util/chart/TimelineChartDataProviderBase
 */

/**
 * Timeline view parameters
 * @typedef {Object} TimelineChartViewConfig
 * @property {Number} width Time axis view model total size
 * @property {Number} height Height of the Gantt body element
 * @property {Number} tickSize Size of the tick
 * @property {Number} projectStartX Project start coordinate relative to the timeline start
 * @property {Number} projectEndX Project end coordinate relative to the timeline end
 */

/**
 * Defines line points. Line point is measured from the top left corner of the SVG canvas. Actual position
 * should be determined by the chart provider.
 * @typedef {Object} TimelineChartLineData
 * @property {Number} x Horizontal coordinate
 * @property {Number} y Vertical coordinate
 */

/**
 * Dataset for the chart
 * @typedef {Object} TimelineChartDataset
 * @property {Number} maxValue Maximum value in the series
 * @property {TimelineChartLineData[]} lineData Line points definition
 */

/**
 * Data series meta data
 * @typedef {Object} DatasetMetaData
 * @property {String} name Dataset name
 * @property {String} text Dataset description
 */

/**
 * Interface for chart data provider.
 *
 * @extends Core/Base
 * @mixes Core/mixin/Events
 * @abstract
 */
export default class TimelineChartDataProviderBase extends Base.mixin(Events) {
    static configurable = {
        /**
         * Default dataset to show.
         *
         * @config {String}
         */
        defaultDataset : undefined
    };

    /**
     * {@link Gantt/feature/TimelineChart} listens to this event to refresh the chart. Trigger this event if data
     * is changed from within the data provider.
     * @event refresh
     */

    /**
     * Returns list of supported datasets.
     *
     * @property {DatasetMetaData[]}
     */
    get datasets() {}

    /**
     * Returns dataset for the chart
     * @param {TimelineChartViewConfig} viewConfig
     * @param {String[]} [datasets] List of dataset names to return
     * @returns {TimelineChartDataset[]}
     */
    getDataset(viewConfig, datasets) {}

    generateDataSets() {}
}
